import React from "react";

interface IProps {
    title?: string,
    placeholder?: string,
    value: string,
    defaultValue?: string,
    onChangeText?: (text: string) => void,
    errMsg?: string,
    disabled?: boolean,
    type?: string,
    min?: string,
    max?: string,
    hideInput?: boolean,
    inputClass?: string,
    titleClass?: string,
}

export default function Form(props: IProps) {
    const {title, onChangeText, errMsg, disabled, hideInput, inputClass, titleClass, defaultValue} = props
    return (
        <div className={"w-full flex flex-col space-y-1"}>
            <p className={`text-sm font-medium text-black leading-5 ${titleClass ? titleClass : ""}`}>{title}</p>
            <input {...props} onChange={(e) => {
                e.preventDefault()
                onChangeText && onChangeText(e.target.value)
            }} disabled={disabled} defaultValue={defaultValue} className={`w-full px-2 py-2.5 text-base text-black rounded-lg border ${hideInput ? "hidden" : ""} ${errMsg && errMsg.length ? "border-error" : "border-[#8698C0]"} transition ease-in-out ${disabled ? "bg-[#E5E5E5]" : ""} ${inputClass ? inputClass : ""}`}
            />
            {errMsg && errMsg.length ? <p className={"text-sm italic text-error"}>{errMsg}</p> : null}
        </div>
    )
}
